import { h, Component } from 'preact';

import { configure } from '../../../../config';

import { COMMON_CONFIGS, getCommonProps } from '../../../../lib/page';
import { trackPageLoad } from '../../../../lib/tracking';

import { ContainerFluid } from '@cube/layout';
import { trackingProvider, DIMENSION } from '@cube/track';
import { Gdpr as GdprWidget } from '@cube/privacy-widgets';

@trackingProvider({
	[DIMENSION.componentpath]: 'GdprPage'
})
@configure({
	...COMMON_CONFIGS
})
export default class Gdpr extends Component {

	componentDidMount() {
		trackPageLoad(this.context);
	}
	
	render( props ) {
		return (
			<ContainerFluid>
				<GdprWidget {...getCommonProps(props)} />
			</ContainerFluid>
		);
	}
}
